<template>
  <div class="roleView">
    <div class="header">
      <div class="title">
        <img src="@/assets/images/informationIcon.png">
        <span>角色</span>
      </div>
      <div class="title" v-if="currentRole.roleName">
        <img src="@/assets/images/userIcon.png">
        <span>{{ currentRole.roleName }}</span>
      </div>
    </div>
    <div class="wrap">
      <div class="tree">
        <div class="addOperationButton" @click="addRoleHandle">
          <i class="iconfont icon-shouqi-icon" />
          <span>添加角色</span>
        </div>
        <ul>
          <li v-for="(item,index) in roleList" :key="index" :class="activeIndex === index ? 'active' : ''">
            <p @click="getEmployeeList(item,index)">{{ item.roleName }}</p>
            <span @click="roleEditHandle(item)">编辑</span>
          </li>
        </ul>
      </div>
      <div class="content">
        <div class="common_btnBar">
          <!--          <span v-if="currentRole.roleName">{{ currentRole.roleName }}</span>-->
          <el-button type="primary" @click="addEmployeeHandle">添加员工</el-button>
          <el-button plain @click="deleteHandle">移除</el-button>
        </div>
        <commonTable ref="roleViewTable" />
      </div>
    </div>
    <addRoleDialog
      :add-role-show="addRoleShow"
      :role-edit-data="roleEditData"
      @dialogCloseHandle="addRoleClose"
      @submitHandle="addRoleSubmit"
      @editHandle="editRoleSubmit"
    />
    <addEmployeeDialog
      :add-employee-show="addEmployeeShow"
      :current-role="currentRole"
      @dialogCloseHandle="addEmployeeClose"
      @submitHandle="addEmployeeSubmit"
    />
  </div>
</template>

<script>
import commonTable from '@/components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
import addRoleDialog from './addRoleDialog';
import addEmployeeDialog from './addEmployeeDialog';
import { roleManagementApi } from '../../service';

export default {
  data () {
    return {
      activeIndex: 0,
      addRoleShow: false,
      addEmployeeShow: false,
      roleList: [],
      employeeList: [],
      currentRole: {},
      roleEditData: {}
    };
  },
  components: {
    commonTable,
    addRoleDialog,
    addEmployeeDialog
  },
  methods: {
    deleteHandle (row) {
      let selectRow = this.$refs.roleViewTable.getCheckboxRecords();
      if (!row.userId && selectRow.length < 1) {
        this.$message.error('请选择要删除的员工');
        return;
      }
      let tipsText = `是否从${ this.currentRole.roleName }角色中删除员工`;
      if (row.userId) {
        tipsText += row.userName;
      } else {
        tipsText += `${ selectRow.length }名`;
      }
      this.$confirm(tipsText, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          role: this.currentRole.roleId
        };
        // 判断其是单个删除还是批量删除
        if (row.userId) {
          params.userIds = [row.userId];
        } else {
          params.userIds = selectRow.map(item => {
            return item.userId;
          });
        }
        this.$refs.roleViewTable.loading = true;
        roleManagementApi.deleteEmployee(params).then(res => {
          if (res.status === '200') {
            this.getEmployeeList(this.currentRole, this.activeIndex);
            this.$refs.roleViewTable.removeRow(row);
            this.$refs.roleViewTable.loading = false;
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }
        });
      }).catch(() => {

      });
    },
    addEmployeeHandle () {
      if (!this.currentRole.roleId) {
        this.$message.error('请选择关联角色');
        return;
      }
      this.addEmployeeShow = true;
    },
    addEmployeeSubmit (data) {
      this.$store.commit('setSubPageLoading', true);
      roleManagementApi.addEmployee(data).then(res => {
        if (res.status === '200') {
          this.$message.success('添加成功');
          this.getEmployeeList(this.currentRole, this.activeIndex);
          this.addEmployeeShow = false;
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    addEmployeeClose () {
      this.addEmployeeShow = false;
    },
    roleEditHandle (item) {
      this.roleEditData = JSON.parse(JSON.stringify(item));
      this.addRoleShow = true;
    },
    editRoleSubmit (data) {
      let params = {
        id: data.id,
        roleId: data.roleId,
        roleName: data.roleName,
        roleNote: data.roleNote ? data.roleNote : ''
      };
      this.$store.commit('setSubPageLoading', true);
      roleManagementApi.editRole(params).then(res => {
        if (res.status === '200') {
          this.getRoleList();
          this.$message.success('编辑成功');
          this.addRoleShow = false;
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    addRoleSubmit (data) {
      this.$store.commit('setSubPageLoading', true);
      roleManagementApi.addRole(data).then(res => {
        if (res.status === '200') {
          this.getRoleList();
          this.$message.success('添加成功');
          this.addRoleShow = false;
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    addRoleClose () {
      this.roleEditData = {};
      this.addRoleShow = false;
    },
    addRoleHandle () {
      this.addRoleShow = true;
    },
    loadTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._width('6%')
          ._others('checkbox')
      );
      tableRow.push(
        new TableColumns()
          ._title('员工账号')
          ._width('10%')
          ._data('userId')
      );
      tableRow.push(
        new TableColumns()
          ._title('员工姓名')
          ._width('10%')
          ._data('userName')
      );
      tableRow.push(
        new TableColumns()
          ._title('职位')
          ._width('10%')
          ._data('bigArea')
      );
      tableRow.push(
        new TableColumns()
          ._title('主属部门')
          ._width('10%')
          ._data('deptName')
      );
      tableRow.push(
        new TableColumns()
          ._title('操作')
          ._width('10%')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="text" onClick={() => { this.deleteHandle(row); }}>
                    移除
                  </el-button>
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$refs.roleViewTable.setColumn(column, {
        page: false
      });
      this.$refs.roleViewTable.loadStaticTable(this.employeeList);
    },
    getEmployeeList (data, index) {
      this.activeIndex = index;
      this.currentRole = data;
      this.$refs.roleViewTable.loading = true;
      roleManagementApi.getEmployeeList(data.roleId).then(res => {
        if (res.status === '200') {
          this.employeeList = res.data;
          this.loadTable();
          this.$refs.roleViewTable.loading = false;
        }
      });
    },
    getRoleList () {
      roleManagementApi.getRoleList().then(res => {
        if (res.status === '200') {
          this.roleList = res.data;
          this.getEmployeeList(this.roleList[0], 0);
        }
      });
    }
  },
  mounted () {
    this.getRoleList();
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/common";
.roleView{
  >.header{
    @extend .clear;
    >.title{
      width: 16%;
      padding: 10px 0;
      line-height: 30px;
      float: left;
      margin-right: 16px;
      >img{
        width: 30px;
        vertical-align: middle;
        margin-right: 12px;
      }
      >span{
        color: #424C57;
        font-size: 16px;
        vertical-align: middle;
      }
    }
  }
  >.wrap{
    display: flex;
    >.tree{
      width: 16%;
      min-height: 100%;
      margin-right: 16px;
      background: #FCFDFE;
      border: 1px solid #DEE1E7;
      >.addOperationButton{
        height: 60px;
        line-height: 60px;
        text-align: center;
        cursor: pointer;
        border-bottom: 1px solid #EDEDED;
        >i{
          margin-right: 10px;
          color: #7E8A9D;
          vertical-align: middle;
        }
        >span{
          color: #424C57;
          vertical-align: middle;
          font-size: 16px;
        }
      }
      >ul{
        >li{
          line-height: 54px;
          position: relative;
          >p{
            padding-left: 20px;
            padding-right: 60px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            cursor: pointer;
            color: #424C57;
          }
          >span{
            display: none;
            position: absolute;
            right: 20px;
            top: 0;
            color: #17A58A;
            cursor: pointer;
          }
          &.active{
            background: #ECF6F5;
            >p{
              color: #17A58A;
            }
          }
          &:hover span{
            display: inline;
          }
        }
      }
    }
    >.content{
      flex: 1;
      min-height: 100%;
      border: 1px solid #DEE1E7;
      background: #FCFDFE;
      padding: 16px;
    }
  }
}
</style>
